import { convert, LocalDate, LocalDateTime, LocalTime, nativeJs, ZonedDateTime, ZoneId } from "@js-joda/core";

export const nativeDateToLocalDateAtUtc = (date: Date): LocalDate => {
   return LocalDate.from(nativeJs(date, ZoneId.UTC));
};

export const nativeDateToLocalTimeAtUtc = (date: Date): LocalTime => {
   return LocalTime.from(nativeJs(date, ZoneId.UTC));
};

export const nativeDateToLocalDateTimeAtUtc = (date: Date): LocalDateTime => {
   return LocalDateTime.from(nativeJs(date, ZoneId.UTC));
};

export const localTimeAtUtcToNativeDate = (localTime: LocalTime): Date => {
   const epoch = LocalDate.ofEpochDay(0);
   return jodaDateTypeAtUtcToNativeDate(LocalDateTime.of(epoch, localTime));
};

export const jodaDateTypeAtUtcToNativeDate = (jodaDateType: LocalDate | LocalDateTime | ZonedDateTime): Date => {
   return convert(jodaDateType, ZoneId.UTC).toDate();
};

export const localDateAtUtcToNativeDate = (localDate: LocalDate): Date => {
   return jodaDateTypeAtUtcToNativeDate(localDate);
};

export const localDateTimeAtUtcToNativeDate = (localDateTime: LocalDateTime): Date => {
   return jodaDateTypeAtUtcToNativeDate(localDateTime);
};

